import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./Languages/de";
import en from "./Languages/en";
import es from "./Languages/es";
import fr from "./Languages/fr";
import it from "./Languages/it";
import pt from "./Languages/pt";
import ro from "./Languages/ro";

export const resources = {
	en: { translation: en },
	it: { translation: it },
	ro: { translation: ro },
	de: { translation: de },
	es: { translation: es },
	pt: { translation: pt },
	fr: { translation: fr },
} as const;

i18n.use(initReactI18next).init({
	lng: "en",
	resources,
});
